import {connect} from 'react-redux';
import UmkCard from '../../components/umk/UmkCard';
import * as actions from '../../actions/umk';
import {withRouter} from 'react-router-dom';
import {fetchCourseBooks, resetCourseBooks} from "../../reducers/CourseBooks/actions";

const mapStateToProps = ({umk, courseBooksReducer}) => ({
    umkCard: umk.umkCard,
    umkContentData: umk.umkContentData,
    umkTypeData: umk.umkTypeData,
    books: courseBooksReducer.list,
});

const mapDispatchToProps = dispatch => ({
    fetchUmkCard: id => dispatch(actions.fetchUmkCard(id)),
    fetchListData: (umkId, listId) => dispatch(actions.fetchListData(umkId, listId)),
    clearUmkData: () => dispatch(actions.clearUmkData()),
    fetchCourseBooks: courseId => dispatch(fetchCourseBooks(courseId)),
    resetCourseBooks: () => dispatch(resetCourseBooks()),
});

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(UmkCard)
);
